import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { confirm } from '../utils/alert';

export default function Navbar() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    const res = await confirm('ອອກຈາກລະບົບ?', '', 'ອອກຈາກລະບົບ');
    if (res.isConfirmed) { logout(); navigate('/'); }
  };

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-dark/95 backdrop-blur-md safe-top">
        <div className="max-w-lg mx-auto px-4 h-16 flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-sand rounded-xl flex items-center justify-center">
              <span className="text-dark font-bold text-sm">MT</span>
            </div>
            <span className="text-cream font-bold text-base tracking-wide">MTonz. DebtBook</span>
          </Link>

          <div className="flex items-center gap-2">
            {isAdmin && (
              // <Link
              //   to="/manage"
              //   className={`px-3 py-1.5 rounded-xl text-xs font-medium transition-all
              //     ${location.pathname === '/manage' ? 'bg-sand text-dark' : 'bg-white/10 text-cream/80'}`}
              // >
              //   ຈັດການ
              // </Link>
              <Link
                to="/"
                className={`px-4 py-2 rounded-xl text-xs font-medium transition-all
                  ${location.pathname === '/' ? 'bg-sand text-dark' : 'bg-white/10 text-cream/80'}`}
              >
                ໜ້າຈັດການ
              </Link>
            )}
            {user ? (
              <button
                onClick={() => setMenuOpen(!menuOpen)}
                className="flex items-center gap-1.5 bg-sand/20 text-sand px-3 py-1.5 rounded-xl text-xs font-medium"
              >
                <span className="w-5 h-5 bg-sand rounded-full flex items-center justify-center text-dark text-xs font-bold">
                  {user.username[0].toUpperCase()}
                </span>
                {user.username}
              </button>
            ) : (
              <Link
                to="/login"
                className="bg-sand text-dark px-4 py-1.5 rounded-xl text-xs font-bold active:scale-95 transition-all"
              >
                ເຂົ້າສູ່ລະບົບ
              </Link>
            )}
          </div>
        </div>
      </nav>

      {/* User menu dropdown */}
      {menuOpen && user && (
        <div className="fixed top-16 right-4 z-50 w-48 bg-dark rounded-2xl shadow-xl overflow-hidden animate-slide-up"
          onClick={() => setMenuOpen(false)}>
          <div className="px-4 py-3 border-b border-white/10">
            <p className="text-cream/60 text-xs">ເຂົ້າສູ່ລະບົບໃນຖານະ</p>
            <p className="text-sand font-bold text-sm">{user.username}</p>
            <p className="text-cream/40 text-xs">Admin</p>
          </div>
          <button onClick={handleLogout}
            className="w-full text-left px-4 py-3 text-red-400 text-sm hover:bg-white/10 transition-all">
            ອອກຈາກລະບົບ
          </button>
        </div>
      )}
      {menuOpen && <div className="fixed inset-0 z-40" onClick={() => setMenuOpen(false)} />}
    </>
  );
}
